function initUspsSliders() {
    document.querySelectorAll('.usps-swiper:not(.swiper-initialized)').forEach(function (el) {
        const spacing = parseInt(el.dataset.slideSpacing) || 20;
        const speed = parseInt(el.dataset.marqueeSpeed) || 2000;
        const pauseOnHover = el.dataset.pauseOnHover === 'true';
        const slideCount = el.querySelectorAll('.swiper-slide').length;

        const swiper = new Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: spacing,
            loop: true,
            loopedSlides: Math.max(slideCount, 10),
            loopAdditionalSlides: 2,
            speed: speed,
            allowTouchMove: false,
            freeMode: {
                enabled: true,
                momentum: false,
                sticky: false,
            },
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
                pauseOnMouseEnter: pauseOnHover,
            },
            breakpoints: {
                1400: {
                    slidesPerView: 6
                },
            },
        });

        swiper.autoplay.start();

        if (pauseOnHover) {
            el.addEventListener('mouseenter', () => swiper.autoplay.stop());
            el.addEventListener('mouseleave', () => swiper.autoplay.start());
        }

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => swiper.update(), 200);
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUspsSliders);
} else {
    initUspsSliders();
}
